import { Contact } from "./Contact";
import { Country } from "./Country";
import { Technology } from "./Technology";
import { Typology } from "./Typology";

export class Organization {

	public id: number;

	public logo: string;

	public name: string;

	public description: string;

	public contacts: Contact[];

	public typology: Typology[];

	public countries: Country[];

	public technologies: Technology[];

}



// WEBPACK FOOTER //
// ./Frontend/src/entity/Organization.ts